import React, {useState} from 'react'

import {ArrLeftIcon, ArrRightIcon} from 'components/CustomIcons'
import Product from 'components/ProductsList/Product'

const ProductSliderMain = ({data}) => {
  const [current, setCurrent] = useState(0)
  const [inTransition, setInTransition] = useState(0)
  const numberOfVisible = 4

  const moveLeft = () => {
    setInTransition(-1)

    setTimeout(() => {
      setInTransition(0)
      setCurrent(c => c - 1)
    }, 300)
  }

  const moveRight = () => {
    setInTransition(1)

    setTimeout(() => {
      setInTransition(0)
      setCurrent(c => c + 1)
    }, 300)
  }

  return <div className='land-prodSliderContainer'>
    <div className='land-prodSliderControls'>
      <button disabled={current <= 0 || !!inTransition} onClick={moveLeft}><ArrLeftIcon/></button>
      <button disabled={current >= (data.length - numberOfVisible) || !!inTransition} onClick={moveRight}><ArrRightIcon/></button>
    </div>

    <div className='land-prodSliderMain' style={inTransition ? {overflow: 'hidden'} : undefined}>
      <div className={inTransition ? inTransition < 0 ? 'land-prodSliderMain-transL' : 'land-prodSliderMain-transR' : ''}>
        {data.map((e, i) => (
          (i >= (current + (inTransition < 0 && -1)) && i < (current + numberOfVisible + (inTransition > 0 && 1))) && (
            <div key={e.uuid}>
              <Product key={e.uuid} product={e}/>
            </div>
          )
        ))}
      </div>
    </div>
  </div>
}

const ProductsSlider = ({Title, Button, data}) => (
  <div>
    <div className='land-prodSliderParent'>
      <div className='land-prodSliderHead group'>
        <div>{Title}</div>
        <div>{Button}</div>
      </div>

      <ProductSliderMain data={data}/>
    </div>
  </div>
)

export default ProductsSlider
